import { combineReducers } from "redux";
import forecast from "./forecast";

const rootReducer = combineReducers({
  forecast,
});

export default rootReducer;
